import React from 'react';
import Component from './logic/Component.js';
import Template from './views/Template.jsx';

/**
 * De React-schil om de logica.
 *
 * Waarom deze tussenlaag? De logica houdt zijn toestand in een gewoon object en
 * verwacht dat een patch er direct in staat, nog voor de hertekening. React werkt
 * anders. Deze schil doet precies wat de dc-runtime deed: patch erin, dan een
 * hertekening aanvragen via een teller die verder niets betekent.
 *
 * Blijf daar vanaf tenzij je alle 250 methodes wilt nalopen op plekken die direct
 * na setState hun eigen state weer uitlezen. Dat zijn er veel.
 */
export default class App extends React.Component {
  constructor(props) {
    super(props);
    this.logic = new Component(props);
    this.logic.__host = this;
    this.state = { tick: 0 };
    /** De laatste render die wél lukte, als vangnet. Zie render(). */
    this.lastVals = null;
    // Alleen tijdens ontwikkelen: een handvat op de logica, zodat je in de
    // console kunt kijken wat de app denkt. Zit niet in de productiebundel.
    if (import.meta.env.DEV) window.__paal = this.logic;
  }

  applyState(update, cb) {
    const prev = this.logic.state;
    const patch = typeof update === 'function' ? update(prev) : update;
    this.logic.state = { ...prev, ...patch };
    this.setState((s) => ({ tick: s.tick + 1 }), cb);
  }

  componentDidMount() {
    this.logic.componentDidMount();
  }

  componentDidUpdate(prevProps) {
    this.logic.props = this.props;
    // Let op: bewust alleen prevProps. De runtime gaf ook nooit een prevState mee,
    // en de logica rekent daarop. Zie het rapport bij "duo-canvas".
    this.logic.componentDidUpdate(prevProps);
  }

  componentWillUnmount() {
    this.logic.componentWillUnmount();
  }


  render() {
    // renderVals raakt zo'n beetje de hele toestand aan. Gooit het één keer, om
    // wat voor rare reden ook, dan is dat geen reden om de hele paal om te gooien:
    // we tekenen de vorige goede stand en de volgende poging herstelt het vanzelf.
    // Lukt het de allereerste keer al niet, dan valt er niets terug te vallen en
    // laten we de fout door naar het scherm hierboven.
    let vals;
    try {
      vals = { ...this.props, ...(this.logic.renderVals() || {}) };
      this.lastVals = vals;
    } catch (e) {
      console.error('[paal] renderVals ging mis:', e);
      // Niets om op terug te vallen: doorgeven aan de grensbewaker in main.jsx.
      if (!this.lastVals) throw e;
      vals = this.lastVals;
    }

    // De twee lagen die de runtime eromheen zette. Ze doen niets zichtbaars,
    // maar de hoogte van de app loopt er wel door.
    return (
      <div id="dc-root">
        <div className="sc-host">
          <Template v={vals} />
        </div>
      </div>
    );
  }
}
